import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { getRankList } from "../Actions/RankManagementAPI";

let userkey = JSON.parse(localStorage.getItem("currentUser"));
const searchData = {
    Name: '',
    PageNumber: 1,
    PageSize: 25
};
class EditRank extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rankInfo: {
                Name: "",
                modifiedBy: userkey.name,
                isDeleted: false
            },
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.UpdateData = this.UpdateData.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { dispatch, RankDetail } = nextProps;
        if (RankDetail && RankDetail !== "") {
            prevState.rankInfo.Name = RankDetail.rankName;
            dispatch({ type: "RankDetail", data: "" });
        }
    }

    handleInputChange(e) {
        this.state.rankInfo.Name = e.target.value;
        this.setState({});
    }

    UpdateData() {
        const { dispatch, match } = this.props;
        const { params } = match;
        const { id } = params;
        let rankInfo = {
            rankId: parseInt(id),
            rankName: this.state.rankInfo.Name,
            isDeleted: false,
            modifiedBy: this.state.rankInfo.modifiedBy,
        };
        let url = `${API.PostRank}`;
        axios.put(url, rankInfo)
            .then((response) => {
                if (response.data) {
                    toast.success("Updated Successfully", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    dispatch(getRankList(searchData));
                    this.hideSidePanel();
                }
                dispatch({
                    type: "UpdateUserSuccess",
                    data: response.data
                })
            })
            .catch((error) => {
                if (error.response.status === 500) {
                    swal("Error!", "Already Exists.", "warning");
                    /*  toast.success(error.response.data.message, {
                         position: "top-right",
                         autoClose: 5000,
                         hideProgressBar: true,
                         closeOnClick: true,
                         pauseOnHover: true,
                         draggable: true,
                         progress: undefined,
                     }); */
                    dispatch({
                        type: "UpdateUserFailure",
                        error: "ERROR"
                    })
                }
                else {
                    swal("Error!", "Something went wrong. Please try again.", "warning");
                    /*  toast.success(error.response.data.message, {
                         position: "top-right",
                         autoClose: 5000,
                         hideProgressBar: true,
                         closeOnClick: true,
                         pauseOnHover: true,
                         draggable: true,
                         progress: undefined,
                     }); */
                    dispatch({
                        type: "UpdateUserFailure",
                        error: "ERROR"
                    })
                }
            })
    }

    hideSidePanel = () => {
        this.props.history.push(`/Home/Management/Rank`);
    };
    BacktoPrevious() {
        this.props.history.goBack();
    }

    render() {
        const { ShipNameList } = this.props;
        return (
            <div className="full-height">
                <div className="pt-3">
                    <div className="row px-3 pb-3">
                        <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            onClick={() => this.BacktoPrevious()}
                        >
                            <div style={{ position: 'relative' }}>
                                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
                            </div>
                        </button>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="panel-box">
                                <div className="card MM-card-header mb-0" style={{ backgroundColor: "white", border: "0px" }}>
                                    <div className="card-body">
                                        <h5 className="card-title ml-1 pl-3 mt-2" style={{ color: "092a51" }}>
                                            Update Rank
                                        </h5>
                                    </div>
                                </div>
                                <div className="search-filter-box">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <label className="form-label">Name</label>
                                            <br></br>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="Name"
                                                placeholder="Name"
                                                value={this.state.rankInfo.Name}
                                                onChange={e => this.handleInputChange(e)}
                                            ></input>
                                        </div>
                                        <div className="col-lg-8">
                                            <label className="mt-4"></label>
                                            <br></br>
                                            <div className="search-btn-col" style={{ textAlign: "end" }}>
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit"
                                                    onClick={() => this.UpdateData()}
                                                >
                                                    {" "}Update{" "}
                                                </button>
                                                <button
                                                    className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                    type="button"
                                                    onClick={() => this.hideSidePanel()}
                                                >
                                                    {" "}Cancel{" "}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        RankDetail: state.RankManagementReducer.RankDetail,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditRank);